import React from "react"
import { Link } from "gatsby"
import Image from "gatsby-image"
import TransitionLink from 'gatsby-plugin-transition-link'

const WorkPostTeaser = ({uri, title, featuredImage, workSectors}) => {
  const thumbnail = {
    fluid: featuredImage?.node?.localFile?.childImageSharp?.fluid,
    alt: featuredImage?.node?.alt || ``,
  }

  return (
    <article
      className="w-full z-20 relative"

      itemScope
      itemType="http://schema.org/Article"
    >
      <Link
        to={uri} className="" itemProp="url">
        <div className="bg-black aspect-ratio-16/9 relative">
          {thumbnail?.fluid && (
            <Image
              fluid={thumbnail.fluid}
              className="w-full h-full video-hover"
              style={{ position: "absolute" }}
              alt={thumbnail.alt}
            />
          )}
        </div>
        <span itemProp="headline" className={`block px-6 med:px-0 pt-4${(title=="Standby Productions Reel") ? ' text-base' : ''}`}>{title}</span>
      </Link>
      <p className="text-sm md:text-base px-6 med:px-0">
      {
        (title != "Standby Productions Reel") && (
          workSectors.map((sector, i) => {
            return(
              <React.Fragment key={i}>
              <Link className="inline-block" to={sector.uri}>
              {sector.name}
              </Link>
              &nbsp;&nbsp;
              </React.Fragment>
            )
          })
        )
        
      }
      </p>
    </article>
  )
}

export default WorkPostTeaser
